import React from "react";
import { Box } from "@mui/material";
import authImage from "../../../../assets/ilustrations/Auth.png";

const AuthIllustration = () => {
  return (
    <Box
      component="img"
      src={authImage}
      alt="Autenticação"
      sx={{
        aspectRatio: "16 / 9",
        backgroundColor: "#f8fafc",
        border: "1px solid #e2e8f0",
        boxShadow: "0 12px 26px rgba(15, 23, 42, 0.055)",
        display: "block",
        maxHeight: { xs: 172, sm: 210 },
        minHeight: { xs: 150, sm: 184 },
        mx: "auto",
        objectFit: "cover",
        objectPosition: "center",
        overflow: "hidden",
        width: "100%",
        borderRadius: 3,
      }}
    />
  );
};

export default AuthIllustration;
